import PlatformLayout from "../components/PlatformLayout";
import { APP_DOMAIN } from "@/config/domain";

export default function PlatformSettingsPage() {
  return (
    <PlatformLayout>
      <div className="max-w-3xl mx-auto">
        <h2 className="text-lg font-semibold text-gray-800 mb-6">系统设置</h2>

        <div className="bg-white rounded-xl border border-gray-100 divide-y divide-gray-100">
          {/* 网站基本信息 */}
          <div className="p-5">
            <h3 className="font-medium text-gray-800 mb-4">网站基本信息</h3>
            <div className="space-y-4">
              <div className="flex items-center justify-between">
                <div>
                  <div className="text-sm font-medium text-gray-700">网站名称</div>
                  <div className="text-sm text-gray-500">分类SaaS平台</div>
                </div>
                <button className="px-3 py-1.5 text-xs font-medium text-blue-500 hover:bg-blue-50 rounded-lg transition-colors cursor-pointer">
                  修改
                </button>
              </div>
              <div className="flex items-center justify-between">
                <div>
                  <div className="text-sm font-medium text-gray-700">网站Logo</div>
                  <div className="text-sm text-gray-500">当前使用默认Logo</div>
                </div>
                <button className="px-3 py-1.5 text-xs font-medium text-blue-500 hover:bg-blue-50 rounded-lg transition-colors cursor-pointer">
                  修改
                </button>
              </div>
            </div>
          </div>

          {/* 域名设置 */}
          <div className="p-5">
            <h3 className="font-medium text-gray-800 mb-4">域名设置</h3>
            <div className="space-y-4">
              <div className="flex items-center justify-between">
                <div>
                  <div className="text-sm font-medium text-gray-700">主域名</div>
                  <div className="text-sm text-gray-500">{APP_DOMAIN}</div>
                </div>
                <button className="px-3 py-1.5 text-xs font-medium text-blue-500 hover:bg-blue-50 rounded-lg transition-colors cursor-pointer">
                  修改
                </button>
              </div>
              <div className="flex items-center justify-between">
                <div>
                  <div className="text-sm font-medium text-gray-700">SSL证书</div>
                  <div className="text-sm text-green-500">已启用</div>
                </div>
                <button className="px-3 py-1.5 text-xs font-medium text-blue-500 hover:bg-blue-50 rounded-lg transition-colors cursor-pointer">
                  管理
                </button>
              </div>
            </div>
          </div>

          {/* 安全设置 */}
          <div className="p-5">
            <h3 className="font-medium text-gray-800 mb-4">安全设置</h3>
            <div className="space-y-4">
              <div className="flex items-center justify-between">
                <div>
                  <div className="text-sm font-medium text-gray-700">两步验证</div>
                  <div className="text-sm text-gray-500">为管理员账号启用两步验证</div>
                </div>
                <button className="px-3 py-1.5 text-xs font-medium text-blue-500 hover:bg-blue-50 rounded-lg transition-colors cursor-pointer">
                  设置
                </button>
              </div>
              <div className="flex items-center justify-between">
                <div>
                  <div className="text-sm font-medium text-gray-700">登录日志</div>
                  <div className="text-sm text-gray-500">查看管理员登录记录</div>
                </div>
                <button className="px-3 py-1.5 text-xs font-medium text-blue-500 hover:bg-blue-50 rounded-lg transition-colors cursor-pointer">
                  查看
                </button>
              </div>
            </div>
          </div>

          {/* 邮件设置 */}
          <div className="p-5">
            <h3 className="font-medium text-gray-800 mb-4">邮件设置</h3>
            <div className="space-y-4">
              <div className="flex items-center justify-between">
                <div>
                  <div className="text-sm font-medium text-gray-700">SMTP服务器</div>
                  <div className="text-sm text-gray-500">smtp.example.com</div>
                </div>
                <button className="px-3 py-1.5 text-xs font-medium text-blue-500 hover:bg-blue-50 rounded-lg transition-colors cursor-pointer">
                  配置
                </button>
              </div>
              <div className="flex items-center justify-between">
                <div>
                  <div className="text-sm font-medium text-gray-700">测试邮件</div>
                  <div className="text-sm text-gray-500">发送测试邮件验证配置</div>
                </div>
                <button className="px-3 py-1.5 text-xs font-medium text-blue-500 hover:bg-blue-50 rounded-lg transition-colors cursor-pointer">
                  发送
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </PlatformLayout>
  );
}
